import { createFileRoute, useParams } from '@tanstack/react-router';

import { GbReportCardDetailPage } from '@/views/admin/gb-report-cards/gb-report-card-detail.tsx';

// gb-report-cards_ 末尾下划线脱离 /admin/gb-report-cards 列表（终端、无 <Outlet/>）的嵌套，
// 在 /admin shell 下独立全屏渲染详情（与 admin.courses_.$id 同模式）；否则 /gb-report-cards/:id
// 会落在列表路由下、因父级无 Outlet 而只显示列表本身。
export const Route = createFileRoute('/admin/gb-report-cards_/$id')({
  component: GbReportCardDetailRoute,
});

function GbReportCardDetailRoute() {
  const { id } = useParams({ from: '/admin/gb-report-cards_/$id' });
  return <GbReportCardDetailPage id={id} />;
}
